(function (angular) {
	'use strict';

	angular
		.module('investorDashboard')
		.controller('DashboardPortfolio', [
			'$timeout',
			'APP_BASE_PATH',
			'Big',
			'DashboardPerformanceService',
			'globalConfig',
			'INVESTMENT_ENTITY_ID',
			'mixpanelFactory',
			'ReitElementFactory',
			'RISE_CO_REIT_ID',
			'PropertyService',
			'urlFactory',
			DashboardPortfolioFunction
		]);

	function DashboardPortfolioFunction(
		$timeout,
		APP_BASE_PATH,
		Big,
		DashboardPerformanceService,
		globalConfig,
		INVESTMENT_ENTITY_ID,
		mixpanelFactory,
		ReitElementFactory,
		RISE_CO_REIT_ID,
		PropertyService,
		urlFactory) {
		
		var dashboard = this;
		dashboard.basePath = APP_BASE_PATH;

		dashboard.navigateToReitPositionView = function(reit) {
			urlFactory.redirect('/activity/reit-investment/' + reit.reitId + '/your-investment'); // need to update to new URL before launch
		};

		dashboard.setActiveMobileColumn = function(table, column) {
			table.activeMobileColumn = column;

			mixpanelFactory.track('Performance Table - Set Active Column', {
				'Table': 'Positions',
				'Column': column
			});
		};

		dashboard.toggleTableSection = function(section) {

			section.expanded = !section.expanded;

			mixpanelFactory.track('Expandable Table - Toggle Section', {
				'Table': 'Positions',
				'Section': section.name,
				'Expand': section.expanded
			});
		};

		(function init() {
			angular.extend(dashboard, globalConfig);

			ReitElementFactory.getReitElementListsForDashboard()
				.then(function(reitElementLists) {
					angular.extend(dashboard, reitElementLists);
				});

			urlFactory.apiGetPromise('/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/portfolio/positions-table').then(function(response) {
				dashboard.positions = response.data;
				dashboard.positions.activeMobileColumn = 'totalValue';
				dashboard.positions.realEstatePositions.name = 'Real estate';
				if(angular.isDefined(dashboard.positions.ipoPosition)){
					dashboard.positions.ipoPosition.name = 'Fundrise iPO';
					dashboard.hasIpo = true;

					DashboardPerformanceService.getReitPositionData(RISE_CO_REIT_ID).then(function(ipoPositionDetailData) {
						var currentIpoSharePrice = new Big(ipoPositionDetailData.currentNav);
						var ipoSharesOwned = new Big(ipoPositionDetailData.sharesOwned);
						var ipoValueBasedOnCurrentSharePrice = String(ipoSharesOwned.times(currentIpoSharePrice));
						dashboard.positions.ipoPosition.estimatedValueOfSharesBasedOnCurrentSharePrice = ipoValueBasedOnCurrentSharePrice;
						dashboard.positions.ipoPosition.sharesOwned = ipoPositionDetailData.sharesOwned;
						dashboard.positions.ipoPosition.currentNav = ipoPositionDetailData.currentNav;
						dashboard.positions.ipoPosition.principalInvested = ipoPositionDetailData.principalOutstanding;
					});

					$timeout(function() {
						dashboard.positions.realEstatePositions.expanded = true;
					});
				}
			});
		})();
	}
})(window.angular);